var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "default-page vertical-align-center" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-center", attrs: { md: "4" } }, [
                _c(
                  "div",
                  { staticClass: "avatar" },
                  [_c("Avatar", { attrs: { avatar: _vm.avatarCatNotebook } })],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "mt-4 mt-md-0",
                  attrs: { md: "4", "offset-md": "1" }
                },
                [
                  _vm.showTitle ? _c("h1", [_vm._v("Login")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.activated
                    ? _c("div", { staticClass: "mt-5 mt-md-0" }, [
                        _c("p", { staticClass: "font-weight-extra-bold" }, [
                          _vm._v("Die Bestätigung hat geklappt!")
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Bitte melde dich jetzt an.")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Wenn du dich auf einem anderen Gerät registriert hast, kannst du dich auch dort nun\n\t\t\t\t\t\tanmelden."
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Login", {
                    staticClass: "mt-4",
                    attrs: { "pre-fill-email": _vm.email }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }